import { Pipe, PipeTransform } from '@angular/core';
import { parseServerUtc } from '../utils/server-time';

// A time from the server as a Date in UTC, to be formatted with the date pipe: `{{ value | serverTime | date: 'd MMM y, HH:mm' }}`.
@Pipe({ name: 'serverTime' })
export class ServerTimePipe implements PipeTransform {
  transform(value: string | null | undefined): Date | null {
    return value ? parseServerUtc(value) : null;
  }
}
